import React from 'react';
import { withWrapper } from '@shared/react';
import {
    AchRelationshipsTableProvider,
    useAchRelationshipsTable,
    getAchRelationshipsTableColumns,
    TRANSACTIONS_TABLE_TITLE,
    TRANSACTIONS_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import { AchRelationshipsTableFilters } from './components';
import './AchRelationshipsTable.scss';

const AchRelationshipsTableContent: React.FC = () => {
    const { achRelationships, achRelationshipsLoading, paginationOptions } = useAchRelationshipsTable();

    return (
        <Table
            columns={getAchRelationshipsTableColumns()}
            data={achRelationships}
            dataLoading={achRelationshipsLoading}
            tableTitle={TRANSACTIONS_TABLE_TITLE}
            infoLink={TRANSACTIONS_TABLE_INFO_URL}
            filters={<AchRelationshipsTableFilters />}
            paginationOptions={paginationOptions}
        />
    );
};

export const AchRelationshipsTable = withWrapper(AchRelationshipsTableProvider)(AchRelationshipsTableContent);
